<template>
    <DeleteJob></DeleteJob>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const DeleteJob = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/DeleteJob.vue"
    )
);

export default {
    name: "Project_HelpDeleteJob", //The name you are in should not equal the name of the component you are importing.
    components: { DeleteJob, AuthLayout },
};
</script>
